import { render, staticRenderFns } from "./GlobalSalesCard.vue?vue&type=template&id=3e701973&"
import script from "./GlobalSalesCard.vue?vue&type=script&lang=js&"
export * from "./GlobalSalesCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSalesCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GlobalSalesCard.vue"
export default component.exports